// AI karsilamasi gelene kadar ziyaretci mesajlarini tutan kapi; karsilama gelmezse sure dolunca acilir.
let pending = null;

function arm(timeoutMs) {
    release();
    let resolveFn;
    const promise = new Promise((resolve) => {
        resolveFn = resolve;
    });
    const timer = setTimeout(() => release(), timeoutMs);
    pending = { promise, resolve: resolveFn, timer };
}

function release() {
    if (!pending) return;
    clearTimeout(pending.timer);
    const { resolve } = pending;
    pending = null;
    resolve();
}

function wait() {
    return pending ? pending.promise : Promise.resolve();
}

function isArmed() {
    return !!pending;
}

module.exports = { arm, release, wait, isArmed };



// WEBPACK FOOTER //
// ./src/utils/openingMessageGate.js